// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Estonia from '../_raw/flag/icon_flag_estonia.png';

export default () => <img src={Estonia} alt="Estonia" />;
